import React from 'react';

const NotificationEmailFirstname = ({ text }) => {
  // Regular expression to match email addresses
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

  const everyoneRegex = /%Everyone%/g; // Case-sensitive %Everyone%

  function formatUsername(email) {
    // Split the email address using "@" as a delimiter
    const parts = email.split('@');
  
    // The username is the first part of the split
    const username = parts[0];
  
    // Replace dots with space in the username
    const formattedUsername = username.replace(/\./g, ' ');
  
    return formattedUsername;
  }

  // Highlight email addresses and occurrences of "Everyone" in the text
  const highlightedText = text.replace(emailRegex, (match) => `<span title="${match}" style="text-transform: capitalize;font-size:13px;display:none" class="highlight">${formatUsername(match)}</span>`)
    .replace(everyoneRegex, '<span class="highlight1">Everyone</span>');


    

  return (
    <span
      style={{
      }}
      className="faqs_items_cls items_cls font-size-new text_overFlow_new_for_notifications"
      dangerouslySetInnerHTML={{
        __html: highlightedText,
      }}
    ></span>
  );
};

export default NotificationEmailFirstname;
